import React from 'react'

export default function InstagramContent() {
  return (
    <div className="bg-black ">
      <h1 className="front-banner-content-heading text-center text-white pt-5">
        Instagram
      </h1>

      <div className="instagram-container">
        <div className='insta-icons'>
        <img
        src="/18.png"
        alt=""
        width="100%"
      />
        </div>
        <div className='insta-icons'>
        <img
        src="/19.png"
        alt=""
        width="100%"
      />
        </div>
        <div className='insta-icons'>
        <img
        src="/21.png"
        alt=""
        width="100%"
      />
        </div>
      </div>
    </div>
  );
}
